import { gql } from 'graphql-request'

export namespace FavoriteMutations {
  export function createFavorite() {
    return gql`
      mutation createFavorite($favorite: CreateFavorite) {
        createFavorite(favorite: $favorite)
      }
    `
  }

  export function deleteFavorite() {
    return gql`
      mutation deleteFavorite($favoriteId: Int!, $favorite: DeleteFavorite) {
        deleteFavorite(favoriteId: $favoriteId, favorite: $favorite)
      }
    `
  }
}
